import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, FileCheck, AlertTriangle, BookOpen, Clock, BarChart, MessageSquare, Calendar, Info, Settings, ChevronLeft, Search } from 'lucide-react';
// Mock bildirim verileri
const notifications = [
// DENEME SINAV SONUÇLARI
{
  id: 1,
  type: 'exam_result',
  title: 'LGS Deneme-5 Sonucu',
  message: "Elif'in deneme sınav sonucu: 67.5 net, sınıf ortalaması: 52.3 net",
  time: '2 saat önce',
  read: false,
  priority: 'success' // yeşil accent
},
// BAŞARI DÜŞÜŞÜ UYARISI
{
  id: 2,
  type: 'performance_warning',
  title: 'Matematik Performansı Uyarısı',
  message: 'Son 3 denemede matematik netinde düşüş gözlemlendi (65→58→52)',
  time: '1 gün önce',
  read: false,
  priority: 'critical' // kırmızı border
},
// TESLİM EDİLMEYEN ÖDEVLER
{
  id: 3,
  type: 'homework_missing',
  title: 'Teslim Edilmeyen Ödev',
  message: 'Fen Bilimleri ödevi bugün teslim edilmeliydi ancak henüz teslim edilmedi',
  time: '3 saat önce',
  read: false,
  priority: 'critical'
},
// ÇALIŞMA PROGRAMI GECİKMELERİ
{
  id: 4,
  type: 'schedule_delay',
  title: 'Program Gecikmesi',
  message: 'Bu hafta planlanan 15 saat çalışmadan sadece 8 saat tamamlandı',
  time: '1 gün önce',
  read: true,
  priority: 'warning'
},
// GÜNLÜK ÇALIŞMA SÜRESİ
{
  id: 5,
  type: 'daily_study',
  title: 'Günlük Çalışma Özeti',
  message: 'Elif bugün toplam 3.5 saat çalıştı, 45 soru çözdü ve 2 video izledi',
  time: '5 saat önce',
  read: true,
  priority: 'normal'
},
// ÖĞRETMENDEN MESAJ
{
  id: 6,
  type: 'teacher_message',
  title: 'Öğretmenden Yeni Mesaj',
  message: 'Ayşe Öğretmen\'den yeni mesaj: "Elif\'in matematik performansı hakkında..."',
  time: '2 gün önce',
  read: false,
  priority: 'normal'
},
// VELİ GÖRÜŞME TALEBİ
{
  id: 7,
  type: 'meeting_request',
  title: 'Veli Görüşme Talebi',
  message: 'Rehber öğretmen bir sonraki hafta görüşme talep ediyor',
  time: '3 gün önce',
  read: true,
  priority: 'normal'
},
// PLATFORM GÜNCELLEMESİ
{
  id: 8,
  type: 'system_update',
  title: 'Platform Güncellemesi',
  message: 'Yeni özellikler eklendi: Gelişmiş analiz raporları ve konu takip sistemi',
  time: '1 hafta önce',
  read: true,
  priority: 'normal'
},
// BAKIM DUYURUSU
{
  id: 9,
  type: 'maintenance',
  title: 'Bakım Çalışması',
  message: 'Yarın saat 02:00-04:00 arasında sistem bakım çalışması yapılacak',
  time: '2 gün önce',
  read: true,
  priority: 'normal'
}];
// Bildirim ikonu getiren yardımcı fonksiyon
const getNotificationIcon = type => {
  switch (type) {
    case 'exam_result':
      return <FileCheck className="w-5 h-5 text-green-400" data-id="element-279" />;
    case 'performance_warning':
      return <AlertTriangle className="w-5 h-5 text-red-400" data-id="element-280" />;
    case 'homework_missing':
      return <BookOpen className="w-5 h-5 text-red-400" data-id="element-281" />;
    case 'schedule_delay':
      return <Clock className="w-5 h-5 text-amber-400" data-id="element-282" />;
    case 'daily_study':
      return <BarChart className="w-5 h-5 text-blue-400" data-id="element-283" />;
    case 'teacher_message':
      return <MessageSquare className="w-5 h-5 text-purple-400" data-id="element-284" />;
    case 'meeting_request':
      return <Calendar className="w-5 h-5 text-indigo-400" data-id="element-285" />;
    case 'system_update':
      return <Info className="w-5 h-5 text-gray-400" data-id="element-286" />;
    case 'maintenance':
      return <Settings className="w-5 h-5 text-gray-400" data-id="element-287" />;
    default:
      return <Bell className="w-5 h-5 text-gray-400" data-id="element-288" />;
  }
};
export function VeliBildirimler() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all'); // 'all', 'unread', 'recent', 'month'
  // Okunmamış bildirimleri hesapla
  const unreadCount = notifications.filter(n => !n.read).length;
  // Son 7 gün içindeki bildirimler
  const last7DaysCount = notifications.filter(notification => notification.time.includes('saat') || notification.time.includes('gün') && parseInt(notification.time) <= 7).length;
  // Son 30 gün içindeki bildirimler
  const last30DaysCount = notifications.filter(notification => notification.time.includes('saat') || notification.time.includes('gün') || notification.time.includes('hafta') && parseInt(notification.time) <= 4).length;
  // Filtreleme işlemi
  const filteredNotifications = notifications.filter(notification => {
    if (filter === 'unread') return !notification.read;
    if (filter === 'recent') {
      // Son 7 gün içindeki bildirimleri filtrele
      return notification.time.includes('saat') || notification.time.includes('gün') && parseInt(notification.time) <= 7;
    }
    if (filter === 'month') {
      // Son 30 gün içindeki bildirimleri filtrele
      return notification.time.includes('saat') || notification.time.includes('gün') || notification.time.includes('hafta') && parseInt(notification.time) <= 4;
    }
    return true; // 'all' filtresi için tüm bildirimleri göster
  });
  return <div className="space-y-6" data-id="element-289">
      {/* Sayfa Başlığı - Sadeleştirilmiş */}
      <div data-id="element-290">
        <h1 className="text-2xl font-bold" data-id="element-291">Bildirimler</h1>
        <p className="text-gray-400 text-sm mt-1" data-id="element-292">
          Çocuğunuzla ilgili tüm bildirimler
        </p>
      </div>
      {/* RENK ANLAMLARI ÖZETİ - HOVER EFEKTİ TAMAMEN YOK */}
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-293">
        <div className="relative p-4 bg-black/90 rounded-lg" data-id="element-294">
          <div className="flex items-center gap-2 mb-3" data-id="element-295">
            <Info className="w-4 h-4 text-blue-400" data-id="element-296" />
            <h3 className="text-sm font-medium text-gray-300" data-id="element-297">
              Bildirim Renk Anlamları
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs" data-id="element-298">
            {/* KIRMIZI - KRİTİK */}
            <div className="flex items-center gap-2" data-id="element-299">
              <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-300"></div>
              <span className="text-gray-400" data-id="element-301">Kritik/Acil</span>
            </div>
            {/* SARI - UYARI */}
            <div className="flex items-center gap-2" data-id="element-302">
              <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-303"></div>
              <span className="text-gray-400" data-id="element-304">Uyarı/Dikkat</span>
            </div>
            {/* YEŞİL - BAŞARI */}
            <div className="flex items-center gap-2" data-id="element-305">
              <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-306"></div>
              <span className="text-gray-400" data-id="element-307">Başarı/Pozitif</span>
            </div>
            {/* MAVİ - NORMAL */}
            <div className="flex items-center gap-2" data-id="element-308">
              <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-309"></div>
              <span className="text-gray-400" data-id="element-310">Normal/Bilgi</span>
            </div>
          </div>
        </div>
      </div>
      {/* FİLTRE BÖLÜMÜ - YENİ TASARIM */}
      <div className="flex flex-wrap gap-3" data-id="element-311">
        {/* TÜMÜ */}
        <button onClick={() => setFilter('all')} className={filter === 'all' ? 'relative p-[1px] rounded-full overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 transition-all hover:shadow-lg hover:shadow-blue-500/25' : 'relative group px-6 py-2.5 rounded-full bg-white/5 border border-gray-700 hover:border-gray-600 hover:bg-white/10 transition-all'} data-id="element-312">
          {filter === 'all' ? <div className="relative px-6 py-2.5 bg-black/90 rounded-full" data-id="element-313">
              <span className="text-sm font-medium text-white" data-id="element-314">Tümü</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-blue-800/20 rounded-full" data-id="element-315"></div>
            </div> : <span className="text-sm text-gray-400 group-hover:text-gray-300" data-id="element-316">
              Tümü
            </span>}
        </button>
        {/* OKUNMAMIŞ */}
        <button onClick={() => setFilter('unread')} className={filter === 'unread' ? 'relative p-[1px] rounded-full overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 transition-all hover:shadow-lg hover:shadow-blue-500/25' : 'relative group px-6 py-2.5 rounded-full bg-white/5 border border-gray-700 hover:border-gray-600 hover:bg-white/10 transition-all'} data-id="element-317">
          {filter === 'unread' ? <div className="relative px-6 py-2.5 bg-black/90 rounded-full" data-id="element-318">
              <span className="text-sm font-medium text-white" data-id="element-319">Okunmamış</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-blue-800/20 rounded-full" data-id="element-320"></div>
            </div> : <>
              <span className="text-sm text-gray-400 group-hover:text-gray-300" data-id="element-321">
                Okunmamış
              </span>
              <span className="ml-2 px-2 py-0.5 bg-red-500/20 text-red-400 rounded-full text-xs font-medium" data-id="element-322">
                {unreadCount}
              </span>
            </>}
        </button>
        {/* SON 7 GÜN */}
        <button onClick={() => setFilter('recent')} className={filter === 'recent' ? 'relative p-[1px] rounded-full overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 transition-all hover:shadow-lg hover:shadow-blue-500/25' : 'relative group px-6 py-2.5 rounded-full bg-white/5 border border-gray-700 hover:border-gray-600 hover:bg-white/10 transition-all'} data-id="element-323">
          {filter === 'recent' ? <div className="relative px-6 py-2.5 bg-black/90 rounded-full" data-id="element-324">
              <span className="text-sm font-medium text-white" data-id="element-325">Son 7 Gün</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-blue-800/20 rounded-full" data-id="element-326"></div>
            </div> : <>
              <span className="text-sm text-gray-400 group-hover:text-gray-300" data-id="element-327">
                Son 7 Gün
              </span>
              <span className="ml-2 px-2 py-0.5 bg-gray-600/30 text-gray-400 rounded-full text-xs" data-id="element-328">
                {last7DaysCount}
              </span>
            </>}
        </button>
        {/* SON 30 GÜN - EK FİLTRE */}
        <button onClick={() => setFilter('month')} className={filter === 'month' ? 'relative p-[1px] rounded-full overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 transition-all hover:shadow-lg hover:shadow-blue-500/25' : 'relative group px-6 py-2.5 rounded-full bg-white/5 border border-gray-700 hover:border-gray-600 hover:bg-white/10 transition-all'} data-id="element-329">
          {filter === 'month' ? <div className="relative px-6 py-2.5 bg-black/90 rounded-full" data-id="element-330">
              <span className="text-sm font-medium text-white" data-id="element-331">Son 30 Gün</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-blue-800/20 rounded-full" data-id="element-332"></div>
            </div> : <>
              <span className="text-sm text-gray-400 group-hover:text-gray-300" data-id="element-333">
                Son 30 Gün
              </span>
              <span className="ml-2 px-2 py-0.5 bg-gray-600/30 text-gray-400 rounded-full text-xs" data-id="element-334">
                {last30DaysCount}
              </span>
            </>}
        </button>
      </div>
      {/* Bildirimler Listesi */}
      {filteredNotifications.length > 0 ? <div className="space-y-4" data-id="element-335">
          {filteredNotifications.map(notification => <div key={notification.id} className={`relative p-[1px] rounded-lg overflow-hidden ${notification.priority === 'critical' ? 'bg-gradient-to-r from-red-500 to-red-600' : notification.priority === 'success' ? 'bg-gradient-to-r from-green-500 to-green-600' : notification.priority === 'warning' ? 'bg-gradient-to-r from-amber-500 to-amber-600' : 'bg-gradient-to-r from-blue-600 to-blue-800'}`} data-id="element-336">
              <div className={`relative p-4 bg-black/90 rounded-lg ${!notification.read ? 'border-l-4 border-blue-500' : ''}`} data-id="element-337">
                <div className="flex items-start gap-4" data-id="element-338">
                  {/* İkon */}
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${notification.priority === 'critical' ? 'bg-red-500/20' : notification.priority === 'success' ? 'bg-green-500/20' : notification.priority === 'warning' ? 'bg-amber-500/20' : 'bg-blue-500/20'}`} data-id="element-339">
                    {getNotificationIcon(notification.type)}
                  </div>
                  {/* İçerik */}
                  <div className="flex-1 min-w-0" data-id="element-340">
                    <div className="flex items-start justify-between gap-2" data-id="element-341">
                      <h3 className={`font-medium ${!notification.read ? 'text-white font-bold' : 'text-gray-300'}`} data-id="element-342">
                        {notification.title}
                        {!notification.read && <span className="w-2 h-2 bg-blue-500 rounded-full inline-block ml-2" data-id="element-343"></span>}
                      </h3>
                      <span className="text-xs text-gray-500 flex-shrink-0" data-id="element-344">
                        {notification.time}
                      </span>
                    </div>
                    <p className={`text-sm mt-1 ${!notification.read ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-345">
                      {notification.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div> :
    // Boş durum
    <div className="text-center py-12" data-id="element-346">
          <Bell className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-347" />
          <h3 className="text-lg font-medium text-gray-400 mb-2" data-id="element-348">
            Henüz bildirim bulunmuyor
          </h3>
          <p className="text-gray-500" data-id="element-349">
            Çocuğunuzla ilgili yeni bildirimler burada görünecek
          </p>
        </div>}
    </div>;
}